interface IStringTMap<T> {
  [key: string]: T;
}

interface IStudentPanelDefinition {
  id: string;
  human: string;
}
// TODO: remove for v3 toggle deprecation
export const StudentPanel: IStringTMap<IStudentPanelDefinition> = {
  STUDENT_SNAPSHOT: {
    id: 'student-snapshot-panel',
    human: 'Student SnapShot',
  },
  STUDENT_GRAD_PLANNING: {
    id: 'student-grad-planning-panel',
    human: 'Graduation & Post-Secondary Planning',
  },
  CURRENT_PROGRAM: {
    id: 'student-current-program-panel',
    human: 'Current Program',
  },
  CREDITS: {
    id: 'student-credits-panel',
    human: 'Credits',
  },
  CREDIT_GAPS: {
    id: 'student-credit-gaps-panel',
    human: 'Credit Gaps',
  },
  REGENTS: {
    id: 'student-regents-panel',
    human: 'Regents',
  },
  ASSIGNED_SUPPORTS: {
    id: 'student-supports-panel',
    human: 'Assigned Supports',
  },
  NOTES: {
    id: 'student-notes-panel',
    human: 'Notes',
  },
  FULL_EXAM_HISTORY: {
    id: 'student-full-exam-history-panel',
    human: 'Full Exam History',
  },
  FULL_TRANSCRIPT_HISTORY: {
    id: 'student-full-transcript-history-panel',
    human: 'Full Transcript History',
  },
};
